/**
 * TODO_Rebate: remove before pushing to production.
 *
 * Dev-only helper that keeps the two rebate mock fixtures present in the
 * campaigns store alongside whatever the (not-yet-ready) real rebate backend
 * returns. Called from `useCampaignsQuery`'s effect for the rebate campaign
 * type once every fetch settles, so it's re-run on every refetch — the
 * presence check below makes repeated calls a no-op once both mocks exist.
 *
 * The dynamic `import()` below is deliberate, not stylistic: `rebateMockData.ts`
 * builds its resource URLs at module-eval time via `buildPortalAssetUrl()` ->
 * `useAppStore.getState()`. A static import of that file from anywhere inside
 * `campaignsStore.ts`'s module graph re-enters the `appStore` <-> `campaigns`
 * circular import mid-cycle and throws `ReferenceError: Cannot access
 * 'useAppStore' before initialization`. Deferring the import until this
 * function is actually invoked (well after the synchronous module graph has
 * finished evaluating) avoids that entirely.
 */
import { isRebateSource, useCampaignsStore } from '../store/campaignsStore';

export const ensureMockRebateCampaigns = async (): Promise<void> => {
  const { mockRebateData, mockRebateDataMulti: _mockRebateDataMulti } = await import('./rebateMockData');
  const { campaigns, addMockCampaign } = useCampaignsStore.getState();
  const rebateIds = new Set(campaigns.filter(isRebateSource).map((c) => c.id));

  if (!rebateIds.has(mockRebateData.id)) {
    addMockCampaign(mockRebateData);
  }
  // if (!rebateIds.has(_mockRebateDataMulti.id)) {
  //   addMockCampaign(_mockRebateDataMulti);
  // }
};
